import { Name } from "../../modules/authentication/domain";

const COLORS = [
  "#F44336",
  "#E91E63",
  "#9C27B0",
  "#673AB7",
  "#3F51B5",
  "#2196F3",
  "#03A9F4",
  "#00BCD4",
  "#009688",
  "#4CAF50",
  "#8BC34A",
  "#CDDC39",
  "#757575",
  "#FFC107",
  "#FF9800",
  "#FF5722",
];

export function getColorFromString(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % COLORS.length;
  return COLORS[index];
}

export function darkenHexColor(hex: string, amount: number = 0.2): string {
  const num = parseInt(hex.slice(1), 16);

  let r = (num >> 16) - 255 * amount;
  let g = ((num >> 8) & 0x00ff) - 255 * amount;
  let b = (num & 0x0000ff) - 255 * amount;

  r = Math.max(0, Math.min(255, r));
  g = Math.max(0, Math.min(255, g));
  b = Math.max(0, Math.min(255, b));

  return `#${(
    (1 << 24) +
    (Math.round(r) << 16) +
    (Math.round(g) << 8) +
    Math.round(b)
  )
    .toString(16)
    .slice(1)}`;
}

export function getInitials(name: Name): string {
  const firstInitial = name.first?.trim()?.charAt(0).toUpperCase() ?? "";
  const lastInitial = name.last?.trim()?.charAt(0).toUpperCase() ?? "";
  return firstInitial + lastInitial;
}

export function getAvatarColors(str: string): {
  background: string;
  text: string;
} {
  const background = getColorFromString(str);
  const text = darkenHexColor(background, 0.3);
  return { background, text };
}
